import { getTargetSystem } from "../../../../../actions/Utilities/ConfigureAgreement";
import { useQuery, useQueryClient } from "react-query";

export default function useGetTargetSystem() {
  return useQuery("GetTargetSystem", getTargetSystem, {
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
}
